import React from 'react';
import PropTypes from 'prop-types';
import TextFormatter from 'utils/TextFormatter';
import SqcPanel from 'equipmentComponents/SqcPanel';
import SqcLevelsButton from 'equipmentComponents/SqcLevelsButton';
import EquipmentUtils from 'utils/EquipmentUtils';

class SqcOutletDisplay extends React.Component {

    render() {
        const {sqcActions, sqcResults, orderId, outlet, showMacAddessOnButton} = this.props;

        const refreshButton = (<SqcLevelsButton
            showMacAddessOnButton={showMacAddessOnButton}
            sqcActions={sqcActions}
            orderId={orderId}
            outlet={outlet}/>);

        if (outlet.get('cutomerOwnedFlag') === true) {
            return null;
        }

        if (!outlet.get('macAddress')) {
            return <h5>No Mac Address Found</h5>;
        }

        if (!sqcResults) {
            return refreshButton;
        }

        if (sqcResults.get('loading') && EquipmentUtils.isHsdEquipment(outlet)) {
            return (
                <div>
                    {refreshButton}
                    <h5>Getting Levels...</h5>
                </div>
            );
        }

        const foundSqc = sqcResults.getIn([
            'details',
            TextFormatter
                .formatMacAddress(outlet.get('macAddress'))
                .toLowerCase()
        ]);

        if (foundSqc) {
            return (
                <div>
                    {refreshButton}
                    <SqcPanel sqc={foundSqc}/>
                </div>
            );
        }

        return refreshButton;
    }
}

SqcOutletDisplay.propTypes = {
    sqcActions: PropTypes.object,
    orderId: PropTypes.string,
    sqcResults: PropTypes.object,
    outlet: PropTypes.object,
    showMacAddessOnButton: PropTypes.bool

};
export default SqcOutletDisplay;



// WEBPACK FOOTER //
// ./src/components/equipment/SqcOutletDisplay.js